import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdminPanelService } from '../../data/admin-panel.service';
import { ColumnConditionBlock, ColumnForEdit } from '../../data/column-for-edit';
import { KbColumnEditorDialogComponent } from './kb-column-editor-dialog/kb-column-editor-dialog.component';
import {Preset} from '../../data/preset';
import {KbPresetEditorDialogComponent} from './kb-preset-editor-dialog/kb-preset-editor-dialog.component';
import {ConfirmationService} from 'primeng/api';
import {PresetService} from '../../data/preset.service';

@Component({
  selector: 'app-kb-column-editor',
  templateUrl: './kb-column-editor.component.html',
  styleUrls: ['./kb-column-editor.component.scss'],
  providers: [ConfirmationService]
})
export class KbColumnEditorComponent implements OnInit {
  columns: ColumnForEdit[]
  columnsMap = new Map<string, ColumnForEdit[]>();
  columnConditionBlock: ColumnConditionBlock[] = []
  presets: Preset[] = [];

  loadingSpinner = true;

  constructor(
    private dialog: MatDialog,
    protected adminPanelService: AdminPanelService,
    private confirmationService: ConfirmationService,
    private presetService: PresetService
  ) {
  }

  ngOnInit(): void {
    this.adminPanelService.getColumnConditions().subscribe(res => {
      this.columns = res;

      this.sortByClazz()
      this.loadingSpinner = false;
    })
    this.loadPresets();
  }

  loadPresets() {
    this.presetService.getPresets().subscribe(res => {
      this.presets = res;
    });
  }

  sortByClazz() {
    this.columnsMap.set('COLUMNS_CONDITION', [])

    this.columns.forEach(cond => {
      this.columnsMap.get('COLUMNS_CONDITION').push(cond)
    })

    this.columnsMap.forEach((val, key) => {
      this.columnConditionBlock.push({
        title: this.adminPanelService.dictsMap.get(key),
        conditions: val
      })
    })
  }

  editColumn(column: ColumnForEdit, index: number, jindex: number) {
    const dialogRef = this.dialog.open(KbColumnEditorDialogComponent, {
      data: {
        column
      },
      panelClass: 'column-editor-dialog'
    });

    dialogRef.afterClosed().subscribe(newDict => {
      if(newDict && newDict instanceof ColumnForEdit) {
        this.columnConditionBlock[index].conditions[jindex] = newDict
      }
    })
  }

  addPreset() {
    this.openPresetDialog(new Preset());
  }

  editPreset(preset: Preset) {
    this.openPresetDialog(preset);
  }

  openPresetDialog(preset: Preset) {
    const dialogRef = this.dialog.open(KbPresetEditorDialogComponent, {
      data: {
        preset,
        allColumns: this.columns
      },
      panelClass: 'preset-editor-dialog'
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.loadPresets();
      }
    });
  }


}
